import { getUniqueString as n } from "../../common/utils/index.js";
import { openBlock as a, createElementBlock as i, normalizeClass as d, renderSlot as r, createTextVNode as o, toDisplayString as l, createCommentVNode as s } from "vue";
import { _ as c } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const g = {
  compatConfig: { MODE: 3 },
  name: "DtListItemGroup",
  props: {
    /**
     * Id of the List Item Group
     */
    id: {
      type: String,
      default() {
        return n();
      }
    },
    /**
     * List's heading.
     */
    heading: {
      type: String,
      default: ""
    },
    /**
     * Additional class to style the heading
     */
    headingClass: {
      type: [String, Array, Object],
      default: ""
    },
    /**
     * Additional class for the wrapper list element.
     */
    listClass: {
      type: [String, Array, Object],
      default: ""
    }
  }
}, u = ["id", "aria-labelledby"], m = ["id"];
function f(t, p, e, h, _, y) {
  return a(), i("ul", {
    id: e.id,
    class: d(["d-list-item-group", e.listClass]),
    role: "group",
    "data-qa": "dt-dropdown-list-wrapper",
    "aria-labelledby": `${e.id}-heading`
  }, [
    e.heading ? (a(), i("li", {
      key: 0,
      id: `${e.id}-heading`,
      role: "presentation",
      "data-qa": "dt-dropdown-list-heading",
      class: d(["dt-dropdown-list--header", e.headingClass])
    }, [
      r(t.$slots, "headingSlot", {}, () => [
        o(l(e.heading), 1)
      ])
    ], 10, m)) : s("", !0),
    r(t.$slots, "default")
  ], 10, u);
}
const w = /* @__PURE__ */ c(g, [["render", f]]);
export {
  w as default
};
//# sourceMappingURL=list-item-group.js.map
